export default {
  name: "profit-or-loses-percent-in-table",
  components: {},
  props: [],
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {}
};
